import React from "react"

import NumberFormat from './numberFormatInput.jsx'
import Dropdown from './semantic-widgets/Dropdown.jsx'
import Accordion from './semantic-widgets/Accordion.jsx'
import Checkbox from './semantic-widgets/Checkbox.jsx'
import MaskedInput from './masked-input/MaskedInput.jsx'
import {Field} from "../modeler/Field.jsx";
import {EditableLabel} from "../modeler/EditableLabel.jsx";
import {Dummy} from "../modeler/Dummy.jsx";
import {MC} from './MC.js';
import {Button} from "./Button.jsx";
import {Camera} from "./Camera.jsx";
import {Repeater} from "./Repeater.jsx";
import {Table} from "./Table.jsx";
import {TabPanel} from "./TabPanel.jsx";
import {Slider} from "./Slider.jsx";
import {Download} from "./Download.jsx";
import {Media} from "./Media.jsx";
import Microphone from "./Microphone.jsx"
import {Link} from "./Link.jsx";
import {EmbeddedDialog} from "./EmbeddedDialog.jsx";
import {WhisperBox} from "./WhisperBox.jsx";
import {Upload} from "./Upload.jsx";
import {Paginator} from "./Paginator.jsx"
import Datebox from "./Datebox.jsx"
import Menu from "./Menu.jsx"
import MenuTree from "./MenuTree.jsx"
import Carousel from './carousel/Carousel.jsx'
import Breadcrumb from './Breadcrumb.jsx'
import ObjectInspector from './ObjectInspector.jsx'
import Steps from './Steps.jsx'
import Iframe from './Iframe.jsx'
import {Value} from "./Value.js"
import tt from "./tooltip/tooltip.js"
import HtmlCustom from "./HtmlCustom.jsx"

class Widget extends React.Component {

  state = this.calculateState(this.props)
  widgetRef = React.createRef()
  widgetRootRef = React.createRef()
  typingTimer = null
  dragFunctionHolder = {dragStartFunction: null}

  componentDidMount() {
    if (!MC.isModelerActive(this.props.widget)) {
      this.props.widget.reactWidget = this
    }
    this.afterUpdate()
    this.scriptedWidget()
    this.updateTooltip()
    this.conditionalForceValidate()
    if (MC.getFieldParamBooleanValue(this.props.widget.param, '@sticky') && !MC.isModelerActive(this.props.widget)) {
      window.addEventListener('scroll', this.handleStickyScroll)
    }
  }

  calculateState(props) {
    let field = props.widget
    let grid = MC.getFieldGrid(field, props.resolution)
    let wideClass = MC.getFieldWideClassFromInt(grid.columns)
    if (MC.isModelerActive(field) && field.isInteractive) {
      wideClass = ""
    }
    let focus = MC.getFieldParamBooleanValue(field.param, '@focused') || false
    if (focus) { // set focused false, for re-render caused by formlogic
      MC.putFieldParamValue(field.param, '@focused', false)
    }
    // set visible true if null
    if (MC.getFieldParamBooleanValue(field.param, '@visible') === null) { 
      MC.putFieldParamValue(field.param, '@visible', true)
    }
    // set enabled true if null
    if (MC.getFieldParamBooleanValue(field.param, '@enabled') === null) { 
      MC.putFieldParamValue(field.param, '@enabled', true)
    }
    return {wideClass: wideClass, focus: focus}
  }

  componentDidUpdate() {
    let nState = this.calculateState(this.props)
    if (this.state.wideClass !== nState.wideClass || this.state.focus !== nState.focus) {
      this.setState(nState)
    }
    this.afterUpdate()
    this.scriptedWidget()
    this.updateTooltip()
    this.conditionalForceValidate()
    if (this.toFocus) {
      let field = this.widgetRootRef.current.querySelector("[data-widget-id='" + this.toFocus.fieldId + "']")
      if (field) {
        field.focus()
      }
      delete this.toFocus 
    }
  }

  componentWillUnmount() {
    if (MC.getFieldParamBooleanValue(this.props.widget.param, '@sticky') && !MC.isModelerActive(this.props.widget)) {
      window.removeEventListener('scroll', this.handleStickyScroll)
    }
    this.destroyTooltip()
    if (!MC.isModelerActive(this.props.widget)) {
      this.props.widget.reactWidget = null
    }
  }

  static buildOptions(field, required, clearable, grabText, withInvalid = true) {
    let values = MC.getFieldParamValue(field.param, 'value*')
    values = MC.isNull(values) ? [] : MC.asArray(values)
    let textValue = grabText ? Value.castToScalar(Value.fromJson(values), 'string').value : null
    let options = []
    if (!required && !MC.getFieldParamBooleanValue(field.param, '@multiple') && !clearable) {
      options.push({value: null, text: ''})
    }
    let items = MC.getFieldParamValue(field.param, 'items*')
    const defaultItems = MC.getFieldParamValue(field.param, 'defaultItems*')
    if (!items && defaultItems && Array.isArray(defaultItems)) {
      items = defaultItems
    }
    let text = null
    if (Array.isArray(items)) {
      let groupsSet = {}
      for (let item of items) {
        if (item['@group'] && !groupsSet[item['@group']]) {
          groupsSet[item['@group']] = true
        }
      }
      let data = []
      if (!MC.isEmptyObject(groupsSet)) {
        for (let groupName in groupsSet) {
          let group = {}
          group.title = groupName
          group.items = []
          for (let item of items) {
            if (item['@group'] == groupName) {
              group.items.push(item)
            }
          }
          data.push(group)
        }
      } else {        
        data.push({title: null, items: items})
      }
      for (let group of data) {
        for (let item of group.items) {
          if (MC.isNull(item['@key'])) {
            continue
          }
          let content = null
          let icon = null
          if (!MC.isNull(item['@imageUrl'])) {
            let imageUrl = MC.rebaseUrl(field.flow, item['@imageUrl'])
            icon = <img src={imageUrl} className={item['@icon']}/>
          } else if (!MC.isNull(item['@icon'])) {
            icon = <i className={MC.buildIconClass(item['@icon'])}></i>
          }
          let title = item['@title'] || item['@key']
          if (icon) {
            content = <React.Fragment>{icon}{title}</React.Fragment>
          }
          if (item['@key'].toString() == textValue && grabText) {
            text = title
          }
          if (MC.getFieldParamValue(field.param, '@escapeHtml') === false) {
            content = <HtmlCustom Tag="div" html={title} />
          }
          options.push({value: item['@key'].toString(), text: title, content: content, url: item['@url'], cssClass: item['@cssClass'], css: MC.styleObjectFromString(item['@css']), group: group.title, disabled: item['@enabled'] == false})
        }
      }
    }
    if (field.widget !== 'unitcombobox' && withInvalid) {
      let allowAdditions = MC.getFieldParamBooleanValue(field.param, '@allowAdditions')
      let invalidValues = MC.getFieldParamValue(field.param, '@invalidValues')
      let checkedValues = []
      if (!MC.getFieldParamBooleanValue(field.param, '@multiple') && values.length > 1) {
        values = [values[0]]
      }
      for (let add of values) {
        add = Value.castToScalar(Value.fromJson(add), 'string').value
        if (!options.find(o => o.value === add)) {
          if (!MC.isNull(add) && ['add', 'mark', 'invalid'].indexOf(invalidValues) >= 0 || allowAdditions) {
            options.unshift({value: add, text: add, content: add, invalid: invalidValues == 'mark' || invalidValues == 'invalid'})
            checkedValues.push(add)
          }
        } else {
          checkedValues.push(add)
        }
      }
      if (checkedValues.length != values.length) {
        MC.putFieldParamValue(field.param, 'value', checkedValues.length == 0 ? null : checkedValues)
        values = checkedValues
      }
    }
    return {options: options, text: text, values: values}
  }

  updateTooltip() {
    let tooltip = MC.getFieldParamValue(this.props.widget.param, '@tooltip')
    let tippyNode = this.widgetRootRef.current
    if (!MC.isNull(tooltip) && tippyNode) {
      if (tooltip !== this.tooltip) {
        this.tooltip = tooltip
        let toolTipHere = tippyNode.querySelector('.tooltip-here')
        if (toolTipHere) {
          tippyNode = toolTipHere
        }
        if (tippyNode._tippy) {
          tippyNode._tippy.destroy()
        }
        if (tooltip) {
          let escape = MC.getFieldParamBooleanValue(this.props.widget.param, '@escapeTooltipHtml')
          let delay = MC.getFieldParamValue(this.props.widget.param, '@tooltipDelay') ?? 400
          tt(tippyNode, {content: tooltip, allowHTML: escape === false, delay: [delay, 0]})
        }
      }
    } else {
      this.destroyTooltip()
    }
  }

  destroyTooltip() {
    if (this.tooltip) {
      this.tooltip = null
      let tippyNode = this.widgetRootRef.current
      if (tippyNode) {
        let toolTipHere = tippyNode.querySelector('.tooltip-here')
        if (toolTipHere) {
          tippyNode = toolTipHere
        }
        if (tippyNode._tippy) {
          tippyNode._tippy.destroy()
        }
      } 
    }
  }

  scriptedWidget() {
    const field = this.props.widget
    if (MC.isModelerActive(field)) {
      return;
    }
    if (field.widget == 'panel' && field.scriptedWidget && field.scriptedWidget.script) {
      let widget;
      if (this.scriptedWidgetObject) {
        widget = this.scriptedWidgetObject
        // in case of scripted widget, we do not use dangerouslySetInnerHTML to not allow React rerendering inner HTML on every update, so onUpdate function is not needed, it is keept in comment for reverting tihs change if needed
        //if (MC.isFunction(widget.onUpdate)) {
        //  widget.onUpdate(this.widgetRef.current, field)
        //}
      } else {
        // in case of scripted widget, we do not use dangerouslySetInnerHTML to not allow React rerendering inner HTML on every update, so onUpdate function is not needed
        this.widgetRef.current.innerHTML = field.scriptedWidget.html || ''
        eval(field.scriptedWidget.script)
      }
      // run scripted widget
      if (widget) {
        if (MC.isFunction(widget.setValue)) {
          let input = MC.extend({}, this.props.widget.param)
          if (!this.scriptedWidgetValue || !MC.objectEqual(this.scriptedWidgetValue, input, true)) {
            this.scriptedWidgetValue = input
            widget.setValue(MC.extend({}, input))
          }
        }
        if (!this.scriptedWidgetObject && MC.isFunction(widget.onCreate)) {
          const options = {iteration: MC.getFieldParamValue(field.param, '@iteration*')}
          widget.onCreate(this.widgetRef.current, field, options)
        }
        this.props.widget.scriptedWidgetObject = widget;
        this.scriptedWidgetObject = widget
      }
    }
  }

  handleStickyScroll = () => {
    var div = this.widgetRootRef.current
    var parentCol = MC.findAncestor(div, 'widget');
    if (parentCol) {
      if (!this.isSticked) {
        this.stickyTop = MC.getElemCoords(div).top;
        var fixedHeader = document.getElementsByClassName('fixed-header-size');
        if (fixedHeader && fixedHeader.length === 1) {
          this.fixedHeaderHeight = fixedHeader[0].getBoundingClientRect().height;
        } else {
          this.fixedHeaderHeight = 0;
        }
      }
      var y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      y = y + this.fixedHeaderHeight;
      if (y >= this.stickyTop) {
        var yD = y + div.getBoundingClientRect().height + 5;
        var stickyBottom = MC.getElemCoords(parentCol).top + parentCol.getBoundingClientRect().height;
        if (yD < stickyBottom) {
          div.style.cssText = "position: relative; top: " + (y - this.stickyTop) + "px;";
        }
        this.isSticked = true;
      } else {
        div.style.cssText = "";
        this.isSticked = false;
      }
    }
  };

  panelOpenClose = (e, active) => {
    MC.putFieldParamValue(this.props.widget.param, '@collapsed', active)
    this.forceUpdate()
    if (MC.isModelerActive(this.props.widget)) {
      modelerChanged("resize")
    } else {
      MC.handleEvent(this.props.widget, 'change')
    }
  }

  afterUpdate() {
    if (this.state.focus) {
      if (this.isDisabled()) return
      var input = this.widgetRef.current
      if (input && MC.isFunction(input.focus)) {
        input.focus()
      } else if (this.widgetRootRef.current) {
        this.widgetRootRef.current.focus()
      }
      var fixedHeader = document.getElementsByClassName('fixed-header-size')
      if (fixedHeader && fixedHeader.length === 1) {
        scrollBy(0, -fixedHeader[0].getBoundingClientRect().height)
      }
      this.setState({focus: false})
    }
    if (this.state.focused) {
      const formatter = MC.getFieldParamValue(this.props.widget.param, '@formatType')
      const disableFormatOnEdit = MC.getFieldParamBooleanValue(this.props.widget.param, '@disableFormatOnEdit')
      if (!MC.isNull(formatter) && disableFormatOnEdit) { // texfield was probably replaced in DOM and must be refocused
        const input = this.widgetRef.current
        if (input && MC.isFunction(input.focus)) {
          input.focus()
        }  
      }
    }
  }

  conditionalForceValidate() {
    if (MC.isModelerActive(this.props.widget)) {
      return
    }
    const forceValidation = MC.getFieldParamBooleanValue(this.props.widget.param, 'validation/@forceValidation')
    if (forceValidation) {
      MC.putFieldParamValue(this.props.widget.param, 'validation/@forceValidation', false)
      this.revalidate(true)
    }
  }

  handleDateChange = (value) => {
    var field = this.props.widget;
    if (value && value.isLuxonDateTime == true) {
      let withTimezone = MC.getFieldParamBooleanValue(field.param, '@outputTimezone')
      switch (field.basictype) {
        case 'dateTime': MC.putFieldParamValue(field.param, 'value', value.toFormat(withTimezone ? "yyyy-MM-dd'T'HH:mm:ss.SSSZZ" : "yyyy-MM-dd'T'HH:mm:ss.SSS")); break
        case 'time': MC.putFieldParamValue(field.param, 'value', value.toFormat(withTimezone ? "HH:mm:ssZZ" : "HH:mm:ss")); break
        default: MC.putFieldParamValue(field.param, 'value', value.toFormat(withTimezone ? "yyyy-MM-ddZZ" : "yyyy-MM-dd")); break
      }
      if (this.props.widget.flow && this.props.widget.flow.getCfgParameter('fl:validationStyle') == 'blur') {
        this.revalidate(true)
      } else {
        this.revalidate()
      }
    } else {
      MC.putFieldParamValue(field.param, 'value', value)
      this.resetValidation()
      this.forceUpdate()
    }
    MC.handleEvent(field, 'change')
  }

  handleTextChange = (e, v, options) => {
    var field = this.props.widget;
    if (MC.isModelerActive(field)) {
      return
    }  
    switch (field.widget) {
      case "checkbox":
        MC.putFieldParamValue(field.param, 'value', v.checked)
        MC.putFieldParamValue(field.param, '@indeterminate', false)
        field.flow.handleSubmit(field)
        break;
      case "combobox":
        MC.putFieldParamValue(field.param, 'value', v.value)
        let options = Widget.buildOptions(field, false, false, !MC.getFieldParamBooleanValue(field.param, '@multiple'))
        MC.putFieldParamValue(field.param, 'text', options.text)
        field.flow.handleSubmit(field)
        break;
      case "colorpalette":
        MC.putFieldParamValue(field.param, 'value', v.value)
        field.flow.handleSubmit(field)
        break;  
      case "whisperbox":
        MC.putFieldParamValue(field.param, 'value', e)
        MC.putFieldParamValue(field.param, 'text', v)
        field.flow.handleSubmit(field)
        break;
      case "radiobutton":
        let parent = this.getParentRadioGorup()
        if (parent) {
          let value = MC.getFieldParamValue(field.param, 'value') ?? true
          if (typeof value == 'boolean') {
            value = true
            let radios = MC.getRadios(parent)
            if (Array.isArray(radios)) {
              for (let radio of radios) {
                MC.putFieldParamValue(radio.param, 'value', field == radio)
              }  
            }
          } 
          MC.putFieldParamValue(parent.param, 'value', value)
        } 
        break;
      case "unitcombobox":  
      default:
        if (!v || v.event || field.widget != "unitcombobox") {
          let formatter = MC.getFieldParamValue(field.param, '@formatType')
          const disableFormatOnEdit = MC.getFieldParamBooleanValue(field.param, '@disableFormatOnEdit')
          if (formatter == 'number' && (!disableFormatOnEdit || !this.state.focused)) {
            MC.putFieldParamValue(field.param, 'value', e.floatValue)
          } else if (e.target.value) {
            let newVal = e.target.value
            let maxLength = MC.getFieldParamValue(field.param, 'validation/@maxLength')
            if (MC.isNumeric(maxLength) && newVal.length > maxLength && formatter != 'mask') { // in mask can be longer
              newVal = MC.getFieldParamValue(field.param, 'value')
            }
            MC.putFieldParamValue(field.param, 'value', newVal)
          } else {
            if (['integer', 'decimal'].indexOf(field.basictype) > -1) {
              this.widgetRef.current.value = '' // because when number type, react is not able delete value
            }
            MC.putFieldParamValue(field.param, 'value', null)
          }
        } else if (field.widget == "unitcombobox") {
          MC.putFieldParamValue(field.param, '@unit', v.value)
        }
    }
    if (['checkbox', 'combobox', 'colorpalette', 'radiobutton'].indexOf(field.widget) > -1) {
      if (field.flow && field.flow.getCfgParameter('fl:validationStyle') == 'blur') {
        this.revalidate(true);
      } else {
        this.revalidate();
      }
    } else {
      this.resetValidation()
      this.forceUpdate()
    }
    Promise.resolve().then(()=>{ MC.handleEvent(field, 'change') }) // this must be called by promise for previous force update take effect before change event started 
    if (['textbox', 'unitbox', 'unitcombobox', 'passwordbox', 'textarea', 'whisperbox'].indexOf(field.widget) > -1 && (!options || !options.notypingbreak)) {
      clearTimeout(this.typingTimer)
      let tbDelay = parseInt(MC.getFieldParamValue(field.param, '@typingbreakDelay')) || 1000
      this.typingTimer = setTimeout(() => {MC.handleEvent(field, 'typingbreak')}, tbDelay)
    }
  }

  handleSearchChange = (sQuery, typingbreak) => {
    let field = this.props.widget
    MC.putFieldParamValue(field.param, '@searchQuery', sQuery)
    clearTimeout(this.typingTimer)
    if (typingbreak) {
      let tbDelay = parseInt(MC.getFieldParamValue(field.param, '@typingbreakDelay')) || 1000
      this.typingTimer = setTimeout(() => { MC.handleEvent(field, 'typingbreak') }, tbDelay)
    }
  }  

  onRadioClick = (e) => {
    if (MC.isModelerActive(this.props.widget)) {
      return
    }
    MC.handleEvent(this.props.widget, 'click', null, e)
  }

  revalidate = (blur) => {
    var field = this.props.widget
    if (MC.getFieldParamBooleanValue(field.param, 'validation/@disableValidation')) {
      return
    }
    this.resetValidation()
    var self = this;
    if (field.widget === "radiobutton") {
      field = this.getParentRadioGorup()
      self = field.reactWidget
    }
    if (MC.getFieldParamBooleanValue(field.param, '@invalid') || blur) { // run only if invalid or blur mode
      try {
        MC.validateField(field)
      } catch (e) {
        field.flow.endOperationException('SYS_InvalidModelExc', e.message)
      }
      MC.updateInvalidSummary(field, true)
      self.forceUpdate()
    } else {
      self.forceUpdate()
    }
  }

  buildSubFields(field, disabled, readOnly, label, textMode) {
    let hrows = MC.renderRows(field.fields, this.props.resolution, disabled, readOnly, textMode)
    if (label) {
      hrows = [<div key="label" className="mnc row mc-label">{label}</div>, ...hrows]
    }
    return hrows
  }

  buildHbox(field, disabled, readOnly, textMode) {
    const className = MC.classes({'flex-grow': MC.getFieldParamBooleanValue(field.param, '@fitWidth'), 'gapped': !MC.getFieldParamBooleanValue(field.param, '@grouped')})
    const rows = MC.splitFieldsIntoRows(field.fields, this.props.resolution) // filter invisible
    const hcolumns = []
    for (const row of rows) {
      for (const subField of row) {
        if (textMode && Widget.hasTextMode(subField)) {
          if (MC.getFieldParamBooleanValue(subField.param, '@focused')) {
            MC.putFieldParamValue(subField.param, '@focused', false)
            this.toFocus = {fieldId: subField.rbsid}
          }
          const wrappercls = MC.classes('mnc wide column field', MC.getFieldParamValue(subField.param, '@cssClassField'), 'textmode widget widget-' + subField.widget)
          hcolumns.push(<div className={className} key={subField.id}><div className={wrappercls} data-widget-id={subField.rbsid} data-widget-name={subField.id} tabIndex="-1" style={MC.styleObjectFromString(MC.getFieldParamValue(subField.param, '@cssField'))}>{Widget.getTextMode(subField, Widget.getValue(subField))}</div></div>)
        } else {
          hcolumns.push(<Widget key={subField.rbsid} widget={subField} disabled={disabled} readOnly={readOnly} resolution={this.props.resolution} wrappingDiv={true} wrappingDivClass={className} textMode={textMode}/>)
        } 
      }
    }
    return hcolumns
  }

  buildVbox(field, disabled, readOnly, textMode) {
    const className = MC.classes({'flex-grow': MC.getFieldParamBooleanValue(field.param, '@fitWidth'), 'gapped': !MC.getFieldParamBooleanValue(field.param, '@grouped')})
    const rows = MC.splitFieldsIntoRows(field.fields, this.props.resolution) // filter invisible
    const vrows = []
    for (const row of rows) {
      for (const subField of row) {
        if (textMode && Widget.hasTextMode(subField)) {
          if (MC.getFieldParamBooleanValue(subField.param, '@focused')) {
            MC.putFieldParamValue(subField.param, '@focused', false)
            this.toFocus = {fieldId: subField.rbsid}
          }
          const wrappercls = MC.classes('mnc wide column field', MC.getFieldParamValue(subField.param, '@cssClassField'), 'textmode widget widget-' + subField.widget)
          vrows.push(<div className={className} key={subField.id}><div className={wrappercls} data-widget-id={subField.rbsid} data-widget-name={subField.id} tabIndex="-1" style={MC.styleObjectFromString(MC.getFieldParamValue(subField.param, '@cssField'))}>{Widget.getTextMode(subField, Widget.getValue(subField))}</div></div>)
        } else {
          vrows.push(<Widget key={subField.rbsid} widget={subField} disabled={disabled} readOnly={readOnly} resolution={this.props.resolution} wrappingDiv={true} wrappingDivClass={className} textMode={textMode}/>)
        }  
      }
    }
    return vrows
  }

  static buildLabel(field, value) {
    value = value || '\u00a0'
    let cssclass = MC.getFieldParamValue(field.param, '@cssClass')
    let css = MC.styleObjectFromString(MC.getFieldParamValue(field.param, '@css'))
    let HeaderType =  MC.getFieldParamValue(field.param, '@headerType')
    let escapeHtml = MC.getFieldParamValue(field.param, '@escapeHtml')    
    if (MC.isNullOrEmpty(HeaderType)) {
      if (escapeHtml !== false) {
        return <span className={cssclass} style={css} id={field.rbsid} data-widget-i-name={field.id} key="labelWrapper">{MC.iconize(field, <span key="labelWrapper">{value}</span>)}</span>
      } else {
        return MC.iconize(field, <HtmlCustom Tag="div" className={cssclass} style={css} id={field.rbsid} html={value} data-widget-i-name={field.id} key="labelWrapper"/>)
      }
    } else {
      let halign = MC.getFieldParamValue(field.param, '@horizontalAlignment')
      cssclass = MC.classes('mnc header flex-row flex-middle', cssclass, {'flex-center': 'center' == halign, 'flex-right': 'right' == halign})
      HeaderType = HeaderType.toLowerCase()
      if (escapeHtml !== false) {
        return <HeaderType className={cssclass} style={css} id={field.rbsid} data-widget-i-name={field.id} key="headerWrapper">{MC.iconize(field, <span key="labelWrapper">{value}</span>)}</HeaderType>
      } else {
        return <HeaderType className={cssclass} style={css} id={field.rbsid} data-widget-i-name={field.id} key="headerWrapper">{MC.iconize(field, <HtmlCustom Tag="div" html={value} key="labelWrapper"/>)}</HeaderType>
      }
    }
  }

  buildColorOptions(field, required, clearable) {
    let options = []
    if (!required && !clearable) {
      options.push({value: '', text: '', content: ( <div className="mnc label delete-color" style={{backgroundColor: 'transparent'}}></div>)})
    }
    let items = MC.getFieldParamValue(field.param, 'items*')
    if (Array.isArray(items)) {
      for (let item of items) {
        let color = item['@color']
        if (MC.isNull(color)) {
          continue
        }
        options.push({value: color, text: color, content: ( <div className="mnc label" style={{backgroundColor: color}}></div>)})
      }
    }
    return {options: options}
  }

  focus = (e) => {
    e.stopPropagation()
    let field = this.props.widget
    if (MC.isModelerActive(field)) {
      return
    }
    this.setState({focused: true})
    if (field.flow && field.flow.getCfgParameter('fl:validationStyle') == 'blur') {
      this.resetValidation()
      this.forceUpdate()
    }
    MC.handleEvent(this.props.widget, 'focus', null, e)
  }

  blur = (e) => {
    if (e) {
      e.stopPropagation()
    }
    let field = this.props.widget
    if (MC.isModelerActive(field) || field.flow.context.action.kind !== 'form') { // blur can be done later than form submit, so flow context data not exists
      return
    }
    if (MC.isNull(MC.getFieldParamValue(field.param, '@formatType'))) {
      let value = MC.getFieldParamValue(field.param, 'value')
      if (!MC.isNull(value) && ['integer', 'decimal'].indexOf(field.basictype) > -1) {
        value = parseFloat(value)
        if (field.basictype == 'integer') {
          value = Math.trunc(value)
        } else {
          let decimalScale = MC.getFieldParamValue(field.param, '@decimalScale')
          if (!MC.isNull(decimalScale)) {
            value = Math.trunc(value*Math.pow(10, decimalScale))/Math.pow(10, decimalScale)
          }
        }
        MC.putFieldParamValue(field.param, 'value', value)
      }
    }
    this.setState({focused: false})
    if (this.props.widget.flow && this.props.widget.flow.getCfgParameter('fl:validationStyle') == 'blur') {
      let avoidBlurValidation = field.widget == 'upload' // in upload widget is blur done when open select file dialog, in this case we do not want validate, validation is done manually after file load
      if (!avoidBlurValidation) {
        this.revalidate(true)
      }
    } else {
      this.revalidate()
    }
    MC.handleEvent(this.props.widget, 'blur', null, e)
  }
  
  checkWarning = () => {
    var field = this.props.widget;
    MC.putFieldParamValue(field.param, "@invalid", false)
    MC.putFieldParamValue(field.param, "@invalidState", 'validChecked')
    MC.putFieldParamValue(field.param, "@invalidmessage", null)
    MC.updateInvalidSummary(field, true)
    //this.forceUpdate()
    this.blur() // because click to checkbox caused focus, it would be maybe better disable focus on checkbox in the future.
  }

  resetValidation = (force = false) => {
    const field = this.props.widget
    if (field.widget == 'upload' && !force) return
    MC.putFieldParamValue(field.param, "@invalid", false)
    MC.putFieldParamValue(field.param, "@invalidState", null)
    MC.putFieldParamValue(field.param, "@invalidmessage", null)
    MC.updateInvalidSummary(field, true)
    this.forceUpdate()
  }

  static hasTextMode(field) {
    if (field.widget == 'radiogroup') {
      return !MC.isModelerActive(field)
    } else {
      return ['checkbox', 'colorpalette', 'combobox', 'datebox', 'label', 'passwordbox', 'slider', 'textbox', 'textarea', 'unitbox', 'unitcombobox', 'upload',  'whisperbox'].indexOf(field.widget) > -1
    }
  }  

  static getValue(field) {
    let val = MC.getFieldParamValue(field.param, 'value')
    if (val == null) {
      val = ""
    }
    let formatter = MC.getFieldParamValue(field.param, '@formatType')
    if (!MC.isNull(formatter) && ['label'].indexOf(field.widget) > -1) {
      if (!MC.isModelerActive(field)) {
        val = MC.formatValue(val, formatter, field.basictype, MC.getFieldParamValue(field.param, '@formatPattern'), {param: MC.mconf.typedParam ? Value.getProperty(field.param, 'value') : Value.fromJson(field.param.value), msgparam: field.msgparam, lang: field.flow.lang})
      } else {
        val = MC.getFieldParamValue(field.param, '@formatPattern')
      }
    } else if (typeof val !== 'string' && !MC.isNull(val)) {
      val = Value.castToScalar(Value.fromJson(val), 'string').value
    }
    return val
  }  

  static getTextMode(field, value) {
    if (['slider', 'textbox', 'unitbox', 'unitcombobox'].indexOf(field.widget) >= 0 && 'number' == MC.getFieldParamValue(field.param, '@formatType')) {
      let decimalScale = Number(MC.getFieldParamValue(field.param, '@decimalScale'))
      if (MC.isNull(decimalScale)) {
        decimalScale = 2
      }
      const prefix = MC.getFieldParamValue(field.param, '@prefix')
      const suffix = MC.getFieldParamValue(field.param, '@suffix')
      value = <NumberFormat key="nm" value={value} decimalSeparator="," thousandSeparator=" " decimalScale={decimalScale} prefix={prefix || ''} suffix={suffix || ''} displayType="text" inputRef={this.widgetRef}/>
    }
    let textValue = null
    if (field.widget == 'combobox' || field.widget == 'unitcombobox') {
      let items = MC.getFieldParamValue(field.param, 'items*')
      const defaultItems = MC.getFieldParamValue(field.param, 'defaultItems*')
      if (!items && defaultItems && Array.isArray(defaultItems)) {
        items = defaultItems
      }
      let values = MC.asArray(field.widget == 'unitcombobox' ? MC.getFieldParamValue(field.param, '@unit') : MC.getFieldParamValue(field.param, 'value*'))
      let res = []
      let invalidValues = MC.getFieldParamValue(field.param, '@invalidValues')
      let target = MC.getFieldParamValue(field.param, '@target')
      target = (['blank', 'parent', 'top'].indexOf(target) > -1) ? '_' + target : null
      for (let value of values) {
        value = Value.castToScalar(Value.fromJson(value), 'string').value
        let item = !MC.isNull(items) ? MC.asArray(items).find(i => i['@key'] === value) : null
        let text
        if (item) {
          let css = MC.styleObjectFromString(item['@css'])
          let cls = MC.classes('mnc value', item['@cssClass'])
          let content = null
          let icon = null
          if (!MC.isNull(item['@imageUrl'])) {
            let imageUrl = MC.rebaseUrl(field.flow, item['@imageUrl'])
            icon = <img src={imageUrl} className={item['@icon']}/>
          } else if (!MC.isNull(item['@icon'])) {
            icon = <i className={MC.buildIconClass(item['@icon'])}></i>
          }
          let title = item['@title'] || item['@key']
          if (icon) {
            content = <React.Fragment>{icon}{title}</React.Fragment>
          }
          if (MC.getFieldParamValue(field.param, '@escapeHtml') === false) {
            content = <HtmlCustom Tag="div" html={title} />
          }
          text = item['@url'] ? <a href={MC.rebaseLink(field.flow, item['@url'])} target={target} className={cls} style={css}>{content ?  content : title}</a> : <span className={cls} style={css}>{content ?  content : title}</span>
        } else {
          text = <span className={invalidValues == 'mark' || invalidValues == 'invalid' ? 'mnc red' : null}>{value}</span>
        }
        res.push(<React.Fragment key={value + '-frg'}>{res.length > 0 ?  ', ' : ''}{text}</React.Fragment>)
      }
      if (field.widget == 'unitcombobox') {
        textValue = MC.getFieldParamValue(field.param, '@unitPlacement') === 'left' ? <span key="ub">{res}&nbsp;{value}</span> : <span key="ub">{value}&nbsp;{res}</span>
      } else {
        textValue = res
      }
    } else if (field.widget == 'datebox') {
      let {dateValue, dateFormat, timeFormat} = MC.prepareDate(field, value, field.basictype)
      if (!dateValue.isValid && !MC.isNull(value)) { // invalid value is not conveted to luxon
        textValue = value
      } else {
        let format = field.basictype == 'time' ? timeFormat : field.basictype == 'date' ? dateFormat : dateFormat + ' ' + timeFormat
        textValue = dateValue.toFormat(format)
      }
    } else if (field.widget == 'passwordbox') {
      textValue = '******'
    } else if (field.widget == 'colorpalette') {  
      textValue = value ? <span className="mnc label" style={{backgroundColor: value}} key="color"></span> : null
    } else if (field.widget == 'checkbox') {
      value = Value.v(value || false, 'boolean')
      if (Value.isTrue(value)) {
        textValue = <i className="mnc icon check square outline" key="ic"/>
      } else if (Value.isFalse(value)) {
        textValue = <i className="mnc icon square outline" key="ic"/>
      }
    } else if (field.widget == 'whisperbox') {
      textValue = <WhisperBox key="ws" data={field} textMode={true}/>
    } else if (field.widget == 'radiogroup') {
      let radios = MC.getRadios(field)
      if (Array.isArray(radios)) {
        for (let radio of radios) {
          if (MC.getFieldParamBooleanValue(radio.param, 'value') || value === MC.getFieldParamValue(radio.param, 'value')) {
            textValue = MC.getFieldParamValue(radio.param, '@title')
            break
          }
        }  
      }
    } else if (field.widget == 'unitbox') {  
      let unit = MC.getFieldParamValue(field.param, '@unit')
      textValue = MC.getFieldParamValue(field.param, '@unitPlacement') === 'left' ? <span key="ub">{unit}&nbsp;{value}</span> : <span key="ub">{value}&nbsp;{unit}</span>
    } else if (field.widget == 'upload') { 
      textValue = <Upload field={field} key="up" textMode={true}/>
    } else if (field.widget == 'label') { 
      textValue = Widget.buildLabel(field, value)
    } else {
      textValue = value
    }
    return MC.isNull(textValue) || textValue === '' ? '\u00A0' : textValue
  }

  handlePanelClick = (e) => {
    const field = this.props.widget
    const url = MC.getFieldParamValue(field.param, '@url')
    if (!MC.isNull(url)) {
      let target = MC.getFieldParamValue(field.param, '@target')
      if (['blank', 'parent', 'top'].indexOf(target) > -1) {
        return
      }
      url = MC.rebaseLink(field.flow, url)
      field.flow.routeTo(e, url)
      return
    }
  }

  getParentRadioGorup = () => {
    let parent = this.props.widget.parent
    if (parent) {
      while ((!parent || parent.widget !== 'radiogroup') && parent.parent) {
        parent = parent.parent
      }
      if (parent && parent.widget === 'radiogroup') {
        return parent
      }
    }
    return false
  }

  isReadOnly() {
    let readOnly = MC.getFieldParamBooleanValue(this.props.widget.param, '@readonly')
    if (!readOnly && (this.props.readOnly || MC.isModelerActive(this.props.widget))) {
      readOnly = true
    }
    return readOnly
  }  

  isDisabled() {
    return !MC.isModelerInEyeMode(this.props.widget) && (MC.getFieldParamValue(this.props.widget.param, '@enabled') == false || this.props.disabled)
  }

  render() {
    var widget;
    var field = this.props.widget;
    if (!MC.isModelerActive(this.props.widget)) {
      field.reactWidget = this
    }
    let defaultValue = Widget.getValue(field)
    var formatter = MC.getFieldParamValue(field.param, '@formatType')
    let icon = MC.getFieldParamValue(field.param, '@icon')
    let iconPlacement = MC.getFieldParamValue(field.param, '@iconPlacement')
    var required = MC.getFieldParamBooleanValue(field.param, 'validation/@required')
    var labelStr = MC.getFieldParamValue(field.param, '@title') || '\u00a0'
    var titlePlacement = MC.getFieldParamValue(field.param, '@titlePlacement')
    if (!titlePlacement) {
      if (['checkbox', 'radiobutton'].includes(field.widget)) {
        titlePlacement = 'R'
      } else if (['breadcrumb', 'button', 'carousel', 'divider', 'download', 'dynamicPanel', 'icon', 'label', 'link', 'menu', 'menutree', 'pagination', 'panel', 'steps'].includes(field.widget)) {
        titlePlacement = 'INV'
      } else {
        titlePlacement = 'UL'
      }
    }
    var label = null
    if (typeof labelStr === 'object') {
      MC.error(`Parameter @title of field "${field.id}" must be a simple value. Value: ${JSON.stringify(labelStr)}`)
    }
    let inputWidth
    if (titlePlacement !== 'INV') {
      if (titlePlacement == 'PI') {
        label = <div key="mnc-header-wrap" className="mnc header-wrap"><h3 className="mnc header editable" key="h3">{MC.iconize(field, <div className="content">{labelStr}</div>)}</h3></div>
      } else {
        let inlineCss = {};
        if (['L', 'LL'].indexOf(titlePlacement) > -1) {
          if (titlePlacement == 'L') {
            inlineCss.textAlign = 'right';
          } else {
            inlineCss.textAlign = 'left';
          }
          var tWidth = MC.getFieldParamValue(field.param, '@titleWidth')
          if (!MC.isNull(tWidth) && MC.isNumeric(tWidth)) {
            inlineCss.width = tWidth + '%'
            inputWidth =  'calc(' + (100 - tWidth) + '% - 10px)'
          }
        }
        var requiredStar = '';
        var escapeHtml = MC.getFieldParamValue(field.param, '@escapeTitleHtml')
        if (escapeHtml !== false) {
          if (required) {
            requiredStar = <span className="rstar">*</span>;
          }
          label = <label className="editable" style={inlineCss} htmlFor={MC.htmlId(field)} key="wlabel">{labelStr}{requiredStar}</label>;
        } else {
          if (required) {
            requiredStar = '<span class="rstar">*</span>';
          }
          label = <HtmlCustom Tag="label" className="editable" style={inlineCss} htmlFor={MC.htmlId(field)} key="wlabel" html={labelStr + requiredStar}/>
        }
      }
      if (MC.isModelerActive(field)) {
        label = <EditableLabel field={field} widget={label} key="EditableLabel" path={["param", "@title"]} nospan={true}/>;
      }
    }
    let readOnly = this.isReadOnly()
    let disabled = this.isDisabled()
    let textMode = MC.getFieldParamBooleanValue(field.param, '@textmode')
    if (!textMode && this.props.textMode) {
      textMode = true
    }
    var halign = MC.getFieldParamValue(field.param, '@horizontalAlignment')
    var maxlength = MC.getFieldParamValue(field.param, 'validation/@maxLength')
    let placeholder = MC.getFieldParamValue(field.param, '@placeholder')
    if (!MC.isNull(placeholder)) {
      placeholder = Value.castToScalar(Value.fromJson(placeholder), 'string').value 
    }
    var help = MC.getFieldParamValue(field.param, '@help')
    var helpDisplay = MC.getFieldParamValue(field.param, '@helpDisplay')
    var invalid = MC.getFieldParamBooleanValue(field.param, '@invalid')
    var invalidState = MC.getFieldParamValue(field.param, '@invalidState')
    var helpCls = 'help';
    var helpCheckbox = null;
    if (invalid) {
      var errMsg = MC.getFieldParamValue(field.param, 'validation/@title')
      if (!MC.isNull(errMsg) && errMsg !== '') {
        help = errMsg;
      } else {
        var invalidMsg = MC.getFieldParamValue(field.param, '@invalidmessage')
        if (!MC.isNull(invalidMsg) && invalidMsg !== '') {
          help = invalidMsg;
        }
      }
      if (invalidState == 'warning') {
        helpCls = 'warning';
        helpCheckbox = <Checkbox key="warning-checkbox" onChange={this.checkWarning}/>;
      } else {
        helpCls = 'error';
      }
    }
    helpDisplay = helpDisplay || 'conditional'
    if ((MC.isNull(help) || help == '') && !MC.isModelerInStructuralMode(field) && helpDisplay == 'yes') {
      help = '\u00a0'
    }
    let errLabel = null
    if (helpDisplay == 'yes' || helpDisplay == 'conditional') {
      if (helpDisplay == 'conditional' && MC.isNull(help) || help === '') {
        errLabel = <label className="help thin" key="error"/>
      } else {
        errLabel = <label className={helpCls} key="error" onClick={(e) => {e.preventDefault()}}>{helpCheckbox}<span className="text">{help}</span></label>
      }
    }
    const inTable = field.isInTable()
    let cssclass = inTable ? this.props.className : Value.v(MC.getFieldParamValue(field.param, '@cssClassField'), 'string').value
    let cssin = Value.v(MC.getFieldParamValue(field.param, '@cssClass'), 'string').value
    let css = MC.styleObjectFromString(MC.getFieldParamValue(field.param, '@css'))
    let inlineCss = inTable ? {...this.props.style} : MC.styleObjectFromString(MC.getFieldParamValue(field.param, '@cssField'))
    var collapsible = MC.getFieldParamBooleanValue(field.param, '@collapsible')
    if (textMode && Widget.hasTextMode(field)) {
      widget = [Widget.getTextMode(field, defaultValue), errLabel]
    } else {
      switch (field.widget) { 
        case 'textbox':
        case 'unitbox':
        case 'unitcombobox':
          const disableFormatOnEdit = MC.getFieldParamBooleanValue(field.param, '@disableFormatOnEdit') // for numeric keyboard on mobile phone
          let decimalScale = Number(MC.getFieldParamValue(field.param, '@decimalScale'))
          if (MC.isNull(decimalScale)) {
            decimalScale = 2
          }
          let mask = MC.getFieldParamValue(field.param, '@formatPattern')
          const size = MC.getFieldParamValue(field.param, '@size')
          if (formatter == 'number' && (!disableFormatOnEdit || !this.state.focused)) {
            const prefix = MC.getFieldParamValue(field.param, '@prefix')
            const suffix = MC.getFieldParamValue(field.param, '@suffix')
            widget = <NumberFormat placeholder={placeholder} value={defaultValue} readOnly={readOnly} disabled={disabled} key="input" size={size}
                      maxLength={maxlength} data-widget-i-name={field.id} className={cssin} style={css} prefix={prefix || ''} suffix={suffix || ''} 
                      decimalSeparator="," thousandSeparator=" " decimalScale={decimalScale} onValueChange={this.handleTextChange} inputRef={this.widgetRef}/>
          } else if (formatter == 'mask' && mask && !MC.isModelerActive(field)) {
            widget = <MaskedInput mask={mask} id={MC.htmlId(field)} placeholder={placeholder} value={defaultValue} readOnly={readOnly} disabled={disabled} size={size}
                                  maxLength={maxlength} onChange={this.handleTextChange} key="input" data-widget-i-name={field.id} className={cssin} style={css} inputRef={this.widgetRef}/>
          } else {
            let type = MC.getFieldParamValue(field.param, '@type') || 'text'
            type = ['integer', 'decimal'].indexOf(field.basictype) > -1 ? 'number' : type
            if (type == 'color' && defaultValue == '') { // avoid warning in js console
              defaultValue = '#000000' // TODO: maybe better to use null value for color type instead of empty string, but it can cause another issues, need to check
            }
            const maxValue = type === 'number' ? MC.getFieldParamValue(field.param, 'validation/@maxValue') : null
            const minValue = type === 'number' ? MC.getFieldParamValue(field.param, 'validation/@minValue') : null
            const step = 'decimal' == field.basictype ? (1/(Math.pow(10, decimalScale))).toString() : '1'
            let onKeyDown = null
            if ('integer' == field.basictype) {
              onKeyDown = function(e) {!['0','1','2','3','4','5','6','7','8','9','-','Backspace','Tab', 'ArrowRight', 'ArrowLeft'].includes(e.key) && !((e.ctrlKey || e.metaKey) && ['c', 'x', 'v'].includes(e.key)) && e.preventDefault()}
            }
            if ('decimal' == field.basictype) {
              onKeyDown = function(e) { !['0','1','2','3','4','5','6','7','8','9','-','.',',','Backspace','Tab', 'ArrowRight', 'ArrowLeft'].includes(e.key) && !((e.ctrlKey || e.metaKey) && ['c', 'x', 'v'].includes(e.key)) && e.preventDefault()}
            } 
            widget = <input type={type} step={step} id={MC.htmlId(field)} ref={this.widgetRef} placeholder={placeholder} value={defaultValue} readOnly={readOnly} disabled={disabled}
                            maxLength={maxlength} onChange={this.handleTextChange} key="input" data-widget-i-name={field.id} className={cssin}
                            style={css} min={minValue} max={maxValue} onKeyDown={onKeyDown} size={size} autoComplete={MC.getFieldParamValue(field.param, '@autocomplete')}/>
          }
          if (icon) {
            widget = <div className={MC.classes("mnc", {"left": iconPlacement !== 'right'}, "icon input")} key="inwrap">{widget}<i key="icon" className={MC.buildIconClass(icon)}></i></div>
          }
          if (field.widget === 'unitbox') {
            var unit = MC.getFieldParamValue(field.param, '@unit')
            var placement = MC.getFieldParamValue(field.param, '@unitPlacement')
            if (placement === 'left') {
              widget = [<div className="mnc labeled input" key="input"><div className="mnc label">{unit}</div>{widget}</div>, errLabel];
            } else {
              widget = [<div className="mnc right labeled input" key="input">{widget}<div className="mnc label">{unit}</div></div>, errLabel];
            }
          } else if (field.widget === 'unitcombobox') {
            var unit = MC.getFieldParamValue(field.param, '@unit')
            var placement = MC.getFieldParamValue(field.param, '@unitPlacement')
            const clearable = MC.getFieldParamBooleanValue(field.param, '@clearable')
            let options = Widget.buildOptions(field, required, clearable)
            if (placement === 'left') {
              widget = ([
                <div className="mnc labeled input" key="field">
                  <Dropdown className="label" value={[unit]} options={options.options} field={field} onChange={this.handleTextChange} key="dropdown" disabled={disabled} clearable={clearable} />
                  {widget}
                </div>,
                errLabel,
                <label className="error" key="error2" style={{display: 'none'}}/>
              ]);
            } else {
              widget = ([
                <div className="mnc right labeled input" key="field">
                  {widget}
                  <Dropdown className="label" value={[unit]} options={options.options} field={field} onChange={this.handleTextChange} key="dropdown" disabled={disabled} clearable={clearable} />
                </div>,
                errLabel,
                <label className="error" key="error2" style={{display: 'none'}}/>
              ]);
            }
          } else {
            widget = [widget, errLabel];
          }
          break;
        case 'datebox':
          widget = [<Datebox key="dtbox" value={defaultValue} field={field} disabled={disabled} readonly={readOnly} placeholder={placeholder} widgetRef={this.widgetRef} 
                             onChange={this.handleDateChange} basicType={field.basictype}/>, errLabel]
          break;
        case 'passwordbox':
          let autocomplete = 'on'
          if (MC.isModelerActive(field)) {
            autocomplete = 'off'
          }
          widget = <input type="password" id={MC.htmlId(field)} ref={this.widgetRef} placeholder={placeholder} value={defaultValue} readOnly={readOnly}
                          disabled={disabled} onChange={this.handleTextChange} key="input" autoComplete={autocomplete} data-widget-i-name={field.id} size={MC.getFieldParamValue(field.param, '@size')} />
          if (icon) {
            widget = <div className={MC.classes("mnc", {"left": iconPlacement !== 'right'}, "icon input")} key="inwrap">{widget}<i key="icon" className={MC.buildIconClass(icon)}></i></div>
          }
          widget = [widget, errLabel]
          break;
        case 'textarea':
          var rows = MC.getFieldParamValue(field.param, '@rows')
          if (MC.isNull(rows) || !MC.isNumeric(rows)) {
            rows = null;
          }
          var resize = MC.getFieldParamBooleanValue(field.param, '@resize')
          var txtStyle = {};
          if (!resize) {
            txtStyle.resize = 'none';
          }
          if (MC.getFieldParamBooleanValue(field.param, '@nowrap')) {
            cssin = MC.classes(cssin, 'nowrap')
          }
          widget = <textarea type="text" id={MC.htmlId(field)} ref={this.widgetRef} placeholder={placeholder} value={defaultValue} readOnly={readOnly} disabled={disabled} maxLength={maxlength} onChange={this.handleTextChange} key="input" 
                     rows={rows} style={{...css, ...txtStyle}} data-widget-i-name={field.id} className={cssin}/>
          widget = [widget, errLabel];
          break;
        case 'upload':
          widget = <Upload field={field} widget={this} key="input" placeholder={placeholder} readOnly={readOnly} disabled={disabled}/>
          widget = [widget, errLabel];
          break;
        case 'checkbox':
          const indeterminate = MC.getFieldParamBooleanValue(field.param, '@indeterminate')
          const checked = defaultValue == true || defaultValue == 'true'
          if (!checked && defaultValue !== false && defaultValue !== 'false') {
            MC.putFieldParamValue(field.param, 'value', false)
          }
          if (indeterminate) {
            MC.putFieldParamValue(field.param, 'value', null)
          }
          if (typeof cssclass == 'string' && cssclass.indexOf("toggle") > -1) {
            cssin += " toggle"
          }
          let inLabel = <label key="chlabel">&nbsp;</label>
          if (titlePlacement == 'R') {
            inLabel = label
            label = ''
          }
          widget = [<Checkbox key="input" label={inLabel} checked={checked} widgetRef={this.widgetRef} indeterminate={indeterminate} field={field} onChange={this.handleTextChange} className={cssin} style={css} disabled={disabled} readOnly={readOnly}/>, errLabel]
          break;
        case 'radiobutton':
          let parent = this.getParentRadioGorup()
          let asButtons = parent && MC.getFieldParamBooleanValue(parent.param, '@asButtons')
          let inLabelR = <label key="chlabel">&nbsp;</label>
          if (titlePlacement == 'R' || asButtons) {
            inLabelR = label
            label = ''
          }
          let selected = defaultValue == true || defaultValue == 'true' || defaultValue === MC.getFieldParamValue(parent.param, 'value')
          widget = [<Checkbox radio key="input" name={parent && parent.rbsid ? parent.rbsid : null} checked={selected} field={field} 
                      onChange={this.handleTextChange} onClick={this.onRadioClick} className={cssin} style={css} disabled={disabled} readOnly={readOnly} label={inLabelR} id={MC.htmlId(field)}/>, errLabel]
          break;
        case 'label':
          widget = Widget.buildLabel(field, defaultValue)
          if (MC.isModelerActive(field)) {
            widget = <EditableLabel key="editableLabel" field={field} widget={widget} path={["param", titlePlacement == "IN" ? "@title" : "value"]}/>;
          }
          widget = [widget, errLabel];
          break;
        case 'button':
          widget = [<Button button={field} widgetRef={this.widgetRef} value={defaultValue} disabled={disabled} key="button"/>, errLabel]
          if (MC.isModelerActive(field)) {
            widget = <EditableLabel key="editableLabel" field={field} widget={widget} path={["param", titlePlacement == "IN" ? "@title" : "value"]}/>;
          }
          break;
        case 'link':
          widget = <Link data={field} widgetRef={this.widgetRef} value={defaultValue} disabled={disabled} key="link"/>
          widget = [widget, errLabel];
          if (MC.isModelerActive(field)) {
            widget = <EditableLabel key="editableLabel" field={field} widget={widget} path={["param", titlePlacement == "IN" ? "@title" : "value"]}/>;
          }
          break;
        case 'combobox':
        case 'colorpalette':
          const	allowAdditions = MC.getFieldParamBooleanValue(field.param, '@allowAdditions')	
          const whisper = MC.getFieldParamBooleanValue(field.param, '@whisper') || allowAdditions
          const clearable = MC.getFieldParamBooleanValue(field.param, '@clearable')
          let multiple = MC.getFieldParamBooleanValue(field.param, '@multiple')
          let options = field.widget === 'colorpalette' ? this.buildColorOptions(field, required, clearable) : Widget.buildOptions(field, required, clearable, !multiple)
          let disabledCmb = false
          if (!MC.isModelerInEyeMode(field) && (disabled || readOnly)) {
            disabledCmb = true
          }
          if (!MC.isNull(options.text)) {
            MC.putFieldParamValue(field.param, 'text', options.text)
          }
          let cls = MC.classes('fluid selection', {'colorpalette': field.widget === 'colorpalette'})
          let onSearch = MC.getFieldParamBooleanValue(field.param, '@customSearch') ? this.handleSearchChange : null
          const openOnFocus = MC.getFieldParamBooleanValue(field.param, '@openOnFocus')
          widget = [<Dropdown className={cls} multiple={multiple} key="dropdown" onChange={this.handleTextChange} search={whisper} value={options.values} options={options.options} field={field}
                      disabled={disabledCmb} placeholder={placeholder} allowAdditions={allowAdditions} clearable={clearable} onSearch={onSearch} widgetRef={this.widgetRef} openOnFocus={openOnFocus} />, errLabel]
          break
        case 'panel':
        case 'radiogroup':
          if (field.widget == 'panel' && field.scriptedWidget) {
            // in case of scripted widget, we do not use dangerouslySetInnerHTML to not allow React rerendering inner HTML on every update, it is keept in comment for reverting tihs change if needed
            // widget =  <div key="scriptedWidget" className="mnc twelve wide column" dangerouslySetInnerHTML={{__html: field.scriptedWidget.html}} ref={this.widgetRef}/>
            widget =  <div key="scriptedWidget" className="mnc twelve wide column" ref={this.widgetRef}/>
          } else {
            if (field.widget == 'radiogroup' && defaultValue === '') {
              let radios = MC.getRadios(field)
              if (Array.isArray(radios)) {
                for (let radio of radios) {
                  if (MC.getFieldParamBooleanValue(radio.param, 'value')) {
                    MC.putFieldParamValue(field.param, 'value', true)
                    break;
                  }
                }  
              }
            }
            let labelToSend = field.widget == 'panel' && titlePlacement == 'PI' && !collapsible ? label : null
            widget = this.buildSubFields(field, disabled, readOnly, labelToSend, textMode)
          }
          if (field.widget == 'radiogroup') {
            widget = [widget, errLabel]
          }
          break;
        case 'hbox':
          widget = this.buildHbox(field, disabled, readOnly, textMode)
          break;
        case 'vbox':
          widget = this.buildVbox(field, disabled, readOnly, textMode)
          break;
        case 'tabpanel':
          widget = <TabPanel key="tabpanel" data={field} disabled={disabled} readOnly={readOnly} resolution={this.props.resolution}/>;
          break;
        case 'repeater':
          widget = <Repeater key="repeater" data={field} disabled={disabled} readOnly={readOnly} textMode={textMode} resolution={this.props.resolution} dragFunctionHolder={this.dragFunctionHolder}/>
          break;
        case 'table':  
          widget = <Table key="table" data={field} disabled={disabled} readOnly={readOnly} textMode={textMode} resolution={this.props.resolution} dragFunctionHolder={this.dragFunctionHolder}/>
          break;
        case 'download':
          if (MC.isModelerActive(field)) {
            widget = <Dummy key="widget" field={field}/>
          } else {
            widget = <Download key="download" data={field}/>
          }
          label = null
          break;
        case 'imageviewer':
        case 'defaultviewer':
        case 'pdfviewer':
        case 'videoviewer':
        case 'audioviewer':  
          widget = [<Media key="media" data={field} halign={halign}/>, errLabel]
          break;
        case 'icon':
            if (icon) {
              widget = <i key="icon" className={MC.buildIconClass(icon, cssin)} id={MC.htmlId(field)} data-widget-i-name={field.id} style={css}/>
            } else if (MC.isModelerActive) {
              widget = <Dummy key="widget" field={field}/>
            }
          break;
        case 'embeddeddialog':
          if (MC.isModelerActive(field)) {
            widget = <Dummy key="widget" field={field}/>;
          } else {
            widget = <EmbeddedDialog key={field.rbsid} data={field} formExecutionId={field.flow.formExecutionId}/>
          }
          break;
        case 'camera':
          widget = <Camera key="camera" data={field} help={help} helpCls={helpCls}/>
          break;
        case 'microphone':
          widget = <Microphone key="microphone" data={field} help={help} helpCls={helpCls}/>
          break;  
        case 'slider':
          widget = [<Slider key="slider" data={field} focused={this.state.focused} widget={this} readOnly={readOnly}/>, errLabel]
          break;
        case 'whisperbox':
          widget = [<WhisperBox key="slider" data={field} placeholder={placeholder} widget={this} readOnly={readOnly} disabled={disabled} widgetRef={this.widgetRef} cssClass={cssin} css={css}/>, errLabel]
          break;
        case 'dynamicPanel':
          widget = this.buildSubFields(field, disabled, readOnly, null, textMode)
          break;
        case 'menu':
          widget = [<Menu key="menu" data={field}/>, errLabel]
          break;
        case 'menutree':
          widget = [<MenuTree key="menu" data={field}/>, errLabel]
          break;
        case 'breadcrumb':
          widget = [<Breadcrumb key="breadcrumb" data={field}/>, errLabel]
          break;  
        case 'carousel':
          const autoplay = MC.getFieldParamBooleanValue(field.param, '@autoplay')
          let autoplayInterval = MC.getFieldParamValue(field.param, '@autoplayInterval')
          if (MC.isNumeric(autoplayInterval)) {
            autoplayInterval = autoplayInterval * 1000
          } else {
            autoplayInterval = 3000
          }
          const wrapAround = MC.getFieldParamBooleanValue(field.param, '@wrapAround')
          widget = <Carousel key="carousel" data={field} autoplay={autoplay} autoplayInterval={autoplayInterval} wrapAround={wrapAround}/>
          break;
        case 'objectinspector':
          const name = MC.getFieldParamValue(field.param, '@name')
          const data = MC.getFieldParamValue(field.param, '@value')
          widget = <ObjectInspector key="obi" data={data} name={name}/> 
          break
        case 'iframe':
          widget = <Iframe field={field} className={cssin} style={css} key="ifr"/> 
          break  
        case 'divider':
          let DivEl = 'div'
          let headerType =  MC.getFieldParamValue(field.param, '@headerType') 
          if (headerType) {
            DivEl = headerType.toLowerCase()
          }
          let vertical = MC.getFieldParamBooleanValue(field.param, '@vertical')
          let hidden = MC.getFieldParamBooleanValue(field.param, '@hiddenLine')
          label = titlePlacement == 'PI' ? null : label
          widget = <DivEl key="dvd" className={MC.classes('mnc', {'horizontal': titlePlacement == 'PI' && !vertical, 'vertical': vertical, 'hidden': hidden}, 'divider', {'header': headerType}, cssin)} style={css} data-widget-i-name={field.id}>{titlePlacement == 'PI' ? MC.iconize(field, labelStr) : null}</DivEl>
          break
        case 'pagination':
          widget = <Paginator field={field} key="pag"/>
          break
        case 'steps':
            widget = <Steps field={field} key="stp"/>
            break  
        default:
          let CustomComponent = MC.getReactRomponent(field.widget)
          let extendedProps = {}
          if ('piechart' == field.widget) {
            extendedProps.type = 'pie'
            CustomComponent = MC.getReactRomponent('chart')
          }
          if ('chart' == field.widget) {
            extendedProps.type = 'basic'
          }
          if (CustomComponent) {
            widget = <CustomComponent key={field.rbsid} data={field} placeholder={placeholder} readOnly={readOnly} disabled={disabled} 
                        value={defaultValue} handleTextChange={this.handleTextChange} {...extendedProps}/>
          } else {
            if (MC.isModelerActive(field)) {
              widget = this.buildSubFields(field, disabled, readOnly, null, textMode)
            } else {
              widget = <span key="unrecognized">Unsupported, or not loaded widget: {field.widget}</span>
            }
          }
          break;
      }
    }
    let valign = MC.getFieldParamValue(field.param, '@verticalAlignment')
    valign = ['top', 'middle', 'bottom'].indexOf(valign) >= 0 ? valign + " aligned" : ""
    let wide = inTable || field.parent && ['hbox', 'vbox'].indexOf(field.parent.widget) > -1 ? '' : this.state.wideClass
    if (field.widget == "repeater" && MC.getFieldParamBooleanValue(field.param, '@inline')) {
      wide = 'twelve'
    }
    cssclass = MC.classes('mnc', wide, "wide column field", cssclass,  {'textmode': textMode, 'inline': ['L', 'LL'].indexOf(titlePlacement) > -1, 
                 'disabled': !MC.isModelerInEyeMode(field) && disabled, 'focused' : this.state.focused}, valign, "widget widget-" + field.widget)
    if (invalid) {
      if (invalidState == 'warning') {
        cssclass = MC.classes(cssclass, 'warning')
      } else {
        cssclass = MC.classes(cssclass, 'error')
      }
    } else {
      if (invalidState == 'valid' || invalidState == 'validChecked') {
        cssclass = MC.classes(cssclass, 'valid')
      }
    }
    if (!MC.isNull(defaultValue) && defaultValue !== '' || field.widget === 'upload') {
      if (["checkbox", "radiogroup", "radiobutton"].indexOf(field.widget) < 0) {
        cssclass = MC.classes(cssclass, 'valued')
      }
    }
    if (['center', 'left', 'right'].indexOf(halign) > -1) {
      inlineCss = {...inlineCss, textAlign: halign} // inline css can be null, so we need to spread it to avoid exception when adding textAlign property
    }
    let collapsed = MC.getFieldParamBooleanValue(field.param, '@collapsed')
    let resField;
    let inputWrapperInlineCss = {}
    if (inputWidth) {
      inputWrapperInlineCss.width = inputWidth
    }
    let gridStyleMod = MC.isModelerActive(field) ? {margin: 0} : {}
  	if (["radiogroup"].indexOf(field.widget) > -1 && (!textMode || MC.isModelerActive(field))) {
      widget = [label, <div key="kd" className={MC.classes("mnc twelve column grid", {"mnc buttons" : MC.getFieldParamBooleanValue(field.param, '@asButtons')})} style={{...inputWrapperInlineCss, ...gridStyleMod}} data-widget-i-name={field.id}>{widget}</div>]
      resField = <Field key="field" widgetRootRef={this.widgetRootRef} field={field} className={cssclass} style={inlineCss} dataWidgetId={field.rbsid} widget={widget} wide={wide} onFocus={this.focus} onBlur={this.blur} colspan={this.props.colspan} rowspan={this.props.rowspan}/>
    } else if (['panel', 'dynamicPanel'].indexOf(field.widget) > -1) {
      label = field.widget == 'panel' && titlePlacement == 'PI' ? null : label
      let href = MC.getFieldParamValue(field.param, '@url')
      let PanelEl =  'div'
      let target = null
      let panelClick = null
      if (href) {
        PanelEl =  'a'
        panelClick = this.handlePanelClick
        target = MC.getFieldParamValue(field.param, '@target')
        if (['blank', 'parent', 'top'].indexOf(target) > -1) {
          target = '_' + target
        }
        href = MC.rebaseLink(field.flow, href)
      }
      if (collapsible) {
        let activeIndex = collapsed ? -1 : 0
        let panel = [{
          key: 'panel',
          title: <span className="mnc header">{labelStr}</span>,
          content: <PanelEl key="kd" className={MC.classes("mnc twelve column grid widgetContainer", cssin)} style={{...css, ...gridStyleMod}} data-widget-i-name={field.id} onClick={panelClick} target={target} href={href}>{widget}</PanelEl>
        }]
        widget = <Accordion fluid panels={panel} onTitleClick={this.panelOpenClose} activeIndex={activeIndex}/>
      } else {
        widget = [label, <PanelEl key="kd" className={MC.classes("mnc twelve column grid widgetContainer", cssin)} style={{...inputWrapperInlineCss, ...css, ...gridStyleMod}} data-widget-i-name={field.id} 
                   onClick={panelClick} target={target} href={href}>{widget}</PanelEl>]
      }
      resField = <Field key="field" widgetRootRef={this.widgetRootRef} field={field} className={cssclass} style={inlineCss} dataWidgetId={field.rbsid} widget={widget} wide={wide} onFocus={this.focus} onBlur={this.blur} colspan={this.props.colspan} rowspan={this.props.rowspan}/>
    } else if (["hbox"].indexOf(field.widget) > -1) {
      let className = MC.classes('hbox flex-row widget-hbox', {'flex-center': halign == 'center', 'flex-right': halign == 'right'}, cssin)
      widget = [label, <div  key="kd" className={className} style={{...inputWrapperInlineCss, ...css}} data-widget-i-name={field.id}>{widget}</div>];
      resField = <Field key="field" widgetRootRef={this.widgetRootRef} field={field} className={cssclass} style={inlineCss} dataWidgetId={field.rbsid} widget={widget} wide={wide} onFocus={this.focus} onBlur={this.blur} colspan={this.props.colspan} rowspan={this.props.rowspan}/>
    } else if (["vbox"].indexOf(field.widget) > -1) {
      if (MC.getFieldParamBooleanValue(field.param, '@fitWidth')) {
        inlineCss = {...inlineCss, height: '100%'} // inline css can be null, so we need to spread it to avoid exception when adding height property
      }
      widget = [label, <div  key="kd" className="vbox flex-column widget-vbox" style={{...inputWrapperInlineCss}} data-widget-i-name={field.id}>{widget}</div>];
      resField = <Field key="field" widgetRootRef={this.widgetRootRef} field={field} className={cssclass} style={inlineCss} dataWidgetId={field.rbsid} widget={widget} wide={wide} onFocus={this.focus} onBlur={this.blur} colspan={this.props.colspan} rowspan={this.props.rowspan}/>
    } else if (field.widget == "repeater") {
      if (collapsible) {
        let activeIndex = collapsed ? -1 : 0
        let panel = [{key: 'panel', title: <span className="mnc header">{labelStr}</span>, content:  widget}]
        widget =  <Accordion panels={panel} onTitleClick={this.panelOpenClose} activeIndex={activeIndex}/>
        resField = <Field key="field" widgetRootRef={this.widgetRootRef} field={field} className={cssclass} style={inlineCss} dataWidgetId={field.rbsid} widget={widget} wide={wide} onFocus={this.focus} onBlur={this.blur} dragFunctionHolder={this.dragFunctionHolder} colspan={this.props.colspan} rowspan={this.props.rowspan}/>
      } else {
        if (inputWidth) {
          widget = <div style={inputWrapperInlineCss}>{widget}</div>
        }
        widget = [label, widget];
        resField = <Field key="field" widgetRootRef={this.widgetRootRef} field={field} className={cssclass} style={inlineCss} dataWidgetId={field.rbsid} widget={widget} wide={wide} onFocus={this.focus} onBlur={this.blur} dragFunctionHolder={this.dragFunctionHolder} colspan={this.props.colspan} rowspan={this.props.rowspan}/>
      }
    } else {
      let cls = cssclass
      if (field.widget == 'checkbox') {
        if (MC.isModelerActive(field)) {
          cls += " read-only";
        }
      } else if (field.widget == 'radiobutton') {
        let parent = this.getParentRadioGorup()
        let radios = MC.asArray(MC.getRadios(parent))
        let asButtons = parent && MC.getFieldParamBooleanValue(parent.param, '@asButtons')
        cls = MC.classes(cls, {"mnc button": asButtons, "active": asButtons && (defaultValue == true || defaultValue == 'true' || defaultValue == MC.getFieldParamValue(parent.param, 'value')), "read-only": MC.isModelerActive(field), 
        "checked": defaultValue == true || defaultValue == 'true', 'first-left': asButtons && field === radios[0], 'last-right': asButtons && field === radios[radios.length - 1]})
      } else if (field.widget == 'upload') {
        cls += " upload";
      }
      if (inputWidth) {
        widget = <div style={inputWrapperInlineCss} key="inwrap">{widget}</div>
      }
      if (MC.isModelerActive(field) && Array.isArray(field.fields) && field.fields.length > 0 && field.widget !== 'tabpanel') { // add grid to unknown widgets with children
        widget = <div key="kd" className="mnc twelve column grid widgetContainer" style={gridStyleMod} data-widget-i-name={field.id}>{widget}</div>
      }
      widget = [label, widget]
      resField = <Field key="field" widgetRootRef={this.widgetRootRef} field={field} className={cls} style={inlineCss} dataWidgetId={field.rbsid} widget={widget} wide={wide} onFocus={this.focus} onBlur={this.blur} colspan={this.props.colspan} rowspan={this.props.rowspan} dragFunctionHolder={this.dragFunctionHolder}/>
    }
    if (this.props.wrappingDiv) {
      resField = <div className={this.props.wrappingDivClass}>{resField}</div>
    }
    return this.props.offsetDiv ? [this.props.offsetDiv, resField] : resField
  }

}

export {Widget}